module.exports = __webpack_public_path__ + "img/nmhxpg-w.ca42fbcd.png";